module["exports"] = [
  "Ds.",
  "Dk.",
  "Gg.",
  "Jln.",
  "Jr.",
  "Kpg.",
  "Ki.",
  "Psr."
];


//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/id_ID/address/street_prefix.js
// module id = 1966
// module chunks = 0